import { createSlice } from '@reduxjs/toolkit';

const positionSlice = createSlice({
  name: 'position',
  initialState: {
    value: '',
  },
  reducers: {
    setPosition: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setPosition } = positionSlice.actions;
export default positionSlice;
